var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"clearfix"},[_c('a-upload',{attrs:{"remove":_vm.handleRemove,"before-upload":_vm.beforeUpload}},[_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" 上传 ")],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }